import React from "react"
import { Link } from 'gatsby'
import Hub from "../../components/layouts/Hub"

export default ({ children }) => {
  return (
    <Hub links={[
      <Link to="/gantt-diagram">Build</Link>,
      <Link to="/gantt-diagram/learn">Learn</Link>,
      <Link to="/gantt-diagram/documentation">Doc</Link>,
    ]}>
      {children}
    </Hub>
  )
}
